import { render, staticRenderFns } from "./BodyPartChangeActivationType.vue?vue&type=template&id=0c5a3a9f&"
import script from "./BodyPartChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./BodyPartChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports